/**
 * @file index.tsx
 *
 * @fileoverview Renders blog search categories badges.
 */

import { FormattedMessage } from 'react-intl';
import Link from '~/jobiqo/components/Link';
import { Term } from '~/jobiqo/types/types';
import { Badge } from '~/vcl/atoms/03-badge';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { getFrontendTheme } from '~/jobiqo/utils/getFrontend';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export interface BlogSearchCategoriesProps {
  /**
   * The categories facet.
   */
  categories: Term[];
  /**
   * The current category.
   */
  currentCategory?: Term;
}

export default function BlogSearchCategories({
  categories,
  currentCategory,
}: BlogSearchCategoriesProps) {
  const frontendConfig = useFrontendConfig();
  const frontendTheme = getFrontendTheme(frontendConfig);
  return (
    <div data-test-id="blog-categories">
      <FlexItems gap={5} justifyContent="center">
        {categories.map((category) => {
          const isCategorySelected = currentCategory?.tid === category.tid;

          return (
            <FlexItem key={category.tid}>
              <Link href={!category.url ? '' : category.url?.path}>
                <Badge
                  badgeStyle={
                    isCategorySelected
                      ? frontendTheme.BLOG.SEARCH_TAGS.SELECTED_STYLE
                      : frontendTheme.BLOG.SEARCH_TAGS.STYLE
                  }
                >
                  {category.label}
                </Badge>
              </Link>
            </FlexItem>
          );
        })}
        <FlexItem>
          <Link href="/blog">
            <Badge
              badgeStyle={
                currentCategory
                  ? frontendTheme.BLOG.SEARCH_TAGS.SELECTED_STYLE
                  : frontendTheme.BLOG.SEARCH_TAGS.STYLE
              }
            >
              <FormattedMessage
                id="categories_badge_all"
                defaultMessage="All"
              />
            </Badge>
          </Link>
        </FlexItem>
      </FlexItems>
    </div>
  );
}

export { BlogSearchCategories };
